export function Footer() {
  return (
    <footer className="bg-muted border-t border-border mt-auto">
      <div className="container mx-auto text-center">
        <p className="text-muted-foreground">&copy; 2025-2026 EasyReports. All rights reserved.</p>
      </div>
    </footer>
  );
}
